import MainNavigation from './mainNavigation';

export default MainNavigation;
